import { QueryCache, QueryClient } from '@tanstack/react-query';
import { captureException, withScope } from '../sentry';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapAxiosErrorToSentryLog = (error: any, queryKey?: string) => {
  withScope((scope) => {
    if (error.response) {
      scope.setContext('response', {
        status: error.response.status,
        headers: error.response.headers,
        data: error.response.data,
      });
    }

    if (queryKey) {
      scope.setTag('queryKey', queryKey);
    }

    captureException(error);
  });
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      mapAxiosErrorToSentryLog(error, query.queryKey.join('.'));
    },
  }),
});
